import axiosInstance from "../AxiosInstance";

export const addUserToDrip = async () => await axiosInstance.get('/drip/addUserToDrip');